/**
 * @generated SignedSource<<3b0bbe39552634eb02ac0c4665428e80>>
 * @relayHash 5ef717426639a092844f99a6b6561da1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ef717426639a092844f99a6b6561da1

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SendChatMessageInput = {
  aiFeatures?: string | null;
  aiTrackingMetadata?: string | null;
  content: string;
  originalContent?: string | null;
  threadId: string;
};
export type useSendChatMessageMutation$variables = {
  connections: ReadonlyArray<string>;
  input: SendChatMessageInput;
};
export type useSendChatMessageMutation$data = {
  readonly sendChatMessage: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly threadId?: string;
    }> | null;
    readonly sendChatMessageOutput: {
      readonly greeting: {
        readonly id: string;
        readonly received: boolean;
      };
      readonly message: {
        readonly content: string | null;
        readonly createdOn: string;
        readonly id: string;
        readonly metadata: {
          readonly aiFeatures: string | null;
          readonly autoTranslationBackTranslatedContent: string | null;
          readonly autoTranslationFailed: boolean | null;
          readonly autoTranslationOriginalContent: string | null;
          readonly autoTranslationTargetLanguage: Language | null;
          readonly autoTranslationTranslatedContent: string | null;
          readonly originalContent: string | null;
          readonly senderUserName: string | null;
        } | null;
        readonly participants: ReadonlyArray<{
          readonly displayName: string | null;
          readonly id: string | null;
        }>;
        readonly senderDisplayName: string | null;
        readonly senderId: string | null;
        readonly type: string;
      };
    } | null;
  };
};
export type useSendChatMessageMutation = {
  response: useSendChatMessageMutation$data;
  variables: useSendChatMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatMessage",
  "kind": "LinkedField",
  "name": "message",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "senderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "senderDisplayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatMessageMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aiFeatures",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "senderUserName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoTranslationOriginalContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoTranslationTranslatedContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoTranslationBackTranslatedContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoTranslationTargetLanguage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoTranslationFailed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatMessageParticipant",
      "kind": "LinkedField",
      "name": "participants",
      "plural": true,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentChatGreeting",
  "kind": "LinkedField",
  "name": "greeting",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "received",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "threadId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*:: as any*/),
  "type": "ChatThreadNotFound",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*:: as any*/),
  "type": "ChatMessageTranslationFailed",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendChatMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "SendChatMessagePayload",
        "kind": "LinkedField",
        "name": "sendChatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SendChatMessageOutput",
            "kind": "LinkedField",
            "name": "sendChatMessageOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useSendChatMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "SendChatMessagePayload",
        "kind": "LinkedField",
        "name": "sendChatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SendChatMessageOutput",
            "kind": "LinkedField",
            "name": "sendChatMessageOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "prependNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "message",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "ChatMessageEdge"
                  }
                ]
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5ef717426639a092844f99a6b6561da1",
    "metadata": {},
    "name": "useSendChatMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "175ceb0a4c7316d054a1c8ccbcd34c7b";

export default node;
